import moment from 'moment';

export default {
  name: 'drop',
  displayName: 'Encouragement',
  subtitle: 'Encouragements are "snackable" deliveries to support and inspire others',
  isPublishable: true,
  uniqKey: '_id',
  crudMapping: {
    create: 'createDrop',
    readMany: 'curatorDrops',
    readOne: 'drop',
    update: 'updateDrop',
    // delete: 'deleteDrop',
  },
  readOneSchema: {
    show: false,
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      if (fieldName === 'published') {
        return value ? 'Yes' : 'No';
      }
      if (fieldName === 'type') {
        switch (value) {
          case 'DROP_TYPE_AUDI':
            return 'Audio & Video';
          case 'DROP_TYPE_EXPE':
            return 'Events & Experiences';
          case 'DROP_TYPE_GIFT':
            return 'Gifts & Goodwill';
          default:
            return 'Words & Phrases';
        }
      }
      if (fieldName === 'updatedAt') {
        if (!value) {
          const date = new Date(parseInt(object._id.substring(0, 8), 16) * 1000);
          return moment(date).format('MM/DD/YYYY hh:mm a');
        }
        return value ? moment(new Date(value)).format('MM/DD/YYYY hh:mm a') : '';
      }

      return value;
    },
    jsonSchema: {
      displayName: 'Encouragement',
      type: 'object',
      filters: [
        {
          field: 'type',
          title: 'Category',
          options: [
            {
              label: 'Audio & Video',
              value: 'DROP_TYPE_AUDI',
            },
            {
              label: 'Events & Experiences',
              value: 'DROP_TYPE_EXPE',
            },
            {
              label: 'Gifts & Goodwill',
              value: 'DROP_TYPE_GIFT',
            },
            {
              label: 'Words & Phrases',
              value: 'DROP_TYPE_WORD',
            },
          ],
        },
      ],
      properties: {
        title: {
          type: 'string',
          title: 'Encouragement Name',
        },
        type: {
          type: 'string',
          title: 'Category',
        },
        published: {
          type: 'boolean',
        },
        updatedAt: {
          title: 'Last Updated',
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      displayName: 'Encouragement',
      description:
        'Complete all required* fields below then select Submit. Your progress will not be saved if you exit the page',
      type: 'object',
      required: ['title', 'type', 'lifeEventIds', 'tags', 'systemTagIds', 'exclusionTagIds', 'hidden'],
      properties: {
        encouragement: {
          type: 'string',
          displayOnly: true,
          title: 'The Encouragement',
          description:
            'Content collected in this section will build the encouragement cards that users interact with.',
        },
        title: {
          type: 'string',
          title: 'Encouragement Name',
          description: 'What is the title of this Encouragement?',
        },
        urlLabel: {
          type: 'string',
          title: 'URL Label',
          description: 'Enter a label that will be everywhere the link shows',
          maxLength: 55,
        },
        url: {
          type: 'string',
          title: 'URL',
          description: 'Copy and paste the complete URL for this encouragement idea',
        },
        content: {
          type: 'string',
          title: 'Tags for Search All',
          description: 'Separate by commas',
        },
        type: {
          type: 'string',
          title: 'Encouragement Category',
          description: 'Select or search for catagories related to this live event.',
          enum: ['DROP_TYPE_AUDI', 'DROP_TYPE_EXPE', 'DROP_TYPE_GIFT', 'DROP_TYPE_WORD'],
          enumNames: [
            'Audio & Video',
            'Events & Experiences',
            'Gifts & Goodwill',
            'Words & Phrases',
          ],
        },
        image: {
          type: 'string',
        },
        lifeevents: {
          type: 'string',
          displayOnly: true,
          title: 'Life Events',
          description: 'Select all Life Events that correlate with this encouragement idea.',
        },
        lifeEventIds: {
          type: 'array',
          title: '',
          count: true,
          hideTitle: true,
          default: [],
          items: {
            type: 'string',
          },
        },
        tagsTitle: {
          type: 'string',
          displayOnly: true,
          title: 'Tags',
          description: 'Tags categorize each encouragement idea',
        },
        tags: {
          type: 'array',
          title: 'General Tags',
          from: 'tagIds',
          description: 'These tags will build a persona around this encouragement idea',
          default: [],
          items: {
            type: 'string',
          },
        },
        systemTagIds: {
          type: 'array',
          title: 'Special Tags',
          from: 'tagIds',
          description:
            ' Special tags refer to the specific age groups, relationships, occupations, and gender tags that should apply to this encouragement.',
          default: [],
          items: {
            type: 'string',
          },
        },
        exclusionTagIds: {
          type: 'array',
          title: 'Exclusion Tags',
          description: 'These tags will remove an encouragement from being recommended.',
          default: [],
          items: {
            type: 'string',
          },
        },
        emailCanBeAutoSend: {
          title: 'Enable autosend for this encouragement',
          type: 'boolean',
          default: true,
        },
        hidden: {
          title: 'Make this Encouragement private (hide from Search All)',
          type: 'boolean',
          default: true,
        },
        published: {
          type: 'boolean',
          default: true,
        },
        openPlatform: {
          type: 'boolean',
          default: false,
        },
      },
    },
    uiSchema: {
      encouragement: {
        'ui:widget': 'sectionWidget',
      },
      published: {
        'ui:widget': 'hidden',
      },
      lifeevents: {
        'ui:widget': 'sectionWidget',
      },
      tagsTitle: {
        'ui:widget': 'sectionWidget',
      },
      lifeEventIds: {
        'ui:field': 'hasManyField',
      },
      image: {
        'ui:widget': 'imageWidget',
        'ui:options': {
          canDelete: true,
        },
      },
      tags: {
        'ui:field': 'hasManyField',
      },
      systemTagIds: {
        'ui:field': 'hasManyField',
      },
      exclusionTagIds: {
        'ui:field': 'hasManyField',
      },
      updatedAt: {
        'ui:widget': 'hidden',
      },
      openPlatform: {
        'ui:widget': 'hidden',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/curator/encouragement.js